import './SetHasPaidModalForm.component.scss';

import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { EEndpoint } from '../../../config/endpoint.config';
import { HttpService } from '../../../services/services.index';
import { setAsPaidGroupMember } from '../../../store/grouplist/grouplist.actions';
import {
  formatCurrencyToNumber,
  normalizeCurrency,
} from '../../../utils/FormNormalizers';

export function SetHasPaidModalFormComponent(props: any) {
  const {
    showModal,
    handleClose,
    pendingPaymentId,
    groupId,
    amount: propsAmount,
    memberName,
  } = props;
  const dispatch = useDispatch();
  const httpService = new HttpService();
  const [inputValue, setInputValue] = useState<string | undefined>('');
  const amount = !!propsAmount ? propsAmount : undefined;

  function resetModal() {
    setInputValue('');
    handleClose();
  }

  async function handleSubmit() {
    try {
      await httpService.patch(
        EEndpoint.SET_VARIABLE_AMOUNT,
        { amount: formatCurrencyToNumber(inputValue as string) },
        {
          params: { pendingPaymentId: pendingPaymentId },
          silently: true,
        },
      );
    } catch {
      resetModal();
    } finally {
      dispatch(setAsPaidGroupMember(groupId, pendingPaymentId));
      resetModal();
    }
  }

  return (
    <Modal
      className='has-paid-modal'
      show={showModal}
      onHide={() => resetModal()}
      size='xl'
      centered
    >
      <Modal.Body>
        <React.Fragment>
          <div className='d-flex justify-content-center align-items-center mb-3'>
            <h6 className='subtitle'>
              <FormattedMessage
                id={`organisms.has-paid-modal.variable-amount.title`}
                values={{ value: <span className='text-primary text-capitalize'>{memberName}</span> }}
              />
            </h6>
          </div>
          <div className='field-container mb-5'>
            <FormattedMessage
              id={
                !!amount
                  ? 'organisms.has-paid-modal.variable-amount.placeholder-has-amount'
                  : 'organisms.has-paid-modal.variable-amount.placeholder-no-amount'
              }
              values={{ value: normalizeCurrency(amount) }}
            >
              {(txt: any) => (
                <input
                  name={'amount'}
                  id='variableAmount'
                  className='field'
                  placeholder={txt}
                  value={inputValue}
                  onChange={(e: any) =>
                    e.target.value === '€ '
                      ? setInputValue('')
                      : setInputValue(normalizeCurrency(e.target.value))
                  }
                  autoComplete='false'
                />
              )}
            </FormattedMessage>
          </div>
          <div className='buttons-container'>
            <button className='btn-lili danger' onClick={() => resetModal()}>
              <FormattedMessage id='common.cancel' />
            </button>
            <button
              className='btn-lili'
              onClick={() => handleSubmit()}
              disabled={!inputValue}
            >
              <FormattedMessage id='common.pay' />
            </button>
          </div>
        </React.Fragment>
      </Modal.Body>
    </Modal>
  );
}
